<template>
  <div>
    <template v-if="extra.included === 'Y'">
      <v-icon
        large
        color="primary"
        class="mb-1"
      >
        mdi-check
      </v-icon>
      <p class="caption font-weight-medium mb-0">
        Included
      </p>
      <p
        v-if="extra.cost && extra.cost.text"
        class="fs-10 mb-0"
        v-html="extra.cost.text"
      />
      <p
        v-else
        class="fs-10 mb-0"
      >
        as standard
      </p>
    </template>

    <template v-if="extra.included === 'extra'">
      <v-fade-transition hide-on-leave>
        <div v-if="!selected">
          <div v-if="extra.cost === null || (!extra.cost.value && !extra.cost.text)">
            <p class="caption font-weight-medium mb-0 has-icon-indent">
              Check with provider
            </p>
          </div>

          <template v-else>
            <v-icon
              large
              color="primary"
              class="mb-1"
            >
              mdi-plus
            </v-icon>

            <div>
              <p class="caption font-weight-medium mb-0">
                Available
              </p>
              <p
                v-if="extra.cost.value"
                class="fs-10 mb-0"
              >
                <template v-if="extra.cost.text">{{ extra.cost.text }}</template>
                <span v-else>from</span>
                <span class="font-weight-medium">
                  &pound;{{ extra.cost.value.toFixed(2) }}
                </span>
              </p>

              <p
                v-else
                class="fs-10 mb-0"
              >
                check with provider
              </p>
            </div>
          </template>
        </div>
      </v-fade-transition>

      <v-fade-transition hide-on-leave>
        <div v-if="selected">
          <div v-if="extra.cost === null || (!extra.cost.value && !extra.cost.text)">
            <p class="caption font-weight-medium mb-0 has-icon-indent">
              Check with provider
            </p>
          </div>

          <template v-else>
            <v-icon
              large
              :color="extra.cost && extra.cost.value ? 'accent' : 'primary'"
              class="mb-1"
            >
              mdi-check
            </v-icon>

            <div>
              <template v-if="extra.cost.value">
                <p class="caption font-weight-medium mb-0">
                  Added
                </p>
                <p class="fs-10 mb-0">
                  at
                  <span class="font-weight-medium">
                    &pound;{{ extra.cost.value.toFixed(2) }}
                  </span>
                </p>
              </template>

              <template v-else>
                <p class="caption font-weight-medium mb-0">
                  Available
                </p>
                <p class="fs-10 mb-0">
                  check with provider
                </p>
              </template>
            </div>
          </template>
        </div>
      </v-fade-transition>
    </template>

    <template v-if="!extra.included || extra.included === 'N'">
      <v-icon
        large
        color="navy-dark"
        class="mb-1"
      >
        mdi-close
      </v-icon>
      <p class="caption font-weight-medium mb-0">
        Not Available
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'results-optional-extra',
  props: {
    extra: {
      type: Object,
      required: false,
      default: () => {},
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang='scss'>
.has-icon-indent {
  margin-top: var(--fz, 28px);
}
</style>
